// Хранилище access/refresh токенов. Работает через shared/lib/persist (LocalStorage) с кешем
// в памяти — прямых обращений к localStorage здесь и в остальном коде быть не должно.

import { LOCAL_STORAGE_KEYS } from '~/shared/config'
import { LocalStorage } from '~/shared/lib/persist'

export type TokenPair = {
  accessToken: string
  refreshToken: string
}

class TokenStorage {
  private readonly accessStorage = new LocalStorage<string>(LOCAL_STORAGE_KEYS.accessToken)
  private readonly refreshStorage = new LocalStorage<string>(LOCAL_STORAGE_KEYS.refreshToken)

  private accessTokenCache: string | null | undefined
  private refreshTokenCache: string | null | undefined

  constructor() {
    // Держим кеш в памяти актуальным при изменениях из других вкладок
    this.accessStorage.subscribe((value) => {
      this.accessTokenCache = value
    })
    this.refreshStorage.subscribe((value) => {
      this.refreshTokenCache = value
    })
  }

  getAccessToken(): string | null {
    if (this.accessTokenCache === undefined) {
      this.accessTokenCache = this.accessStorage.getCurrentValue()
    }
    return this.accessTokenCache
  }

  getRefreshToken(): string | null {
    if (this.refreshTokenCache === undefined) {
      this.refreshTokenCache = this.refreshStorage.getCurrentValue()
    }
    return this.refreshTokenCache
  }

  setTokens(tokens: TokenPair): void {
    this.accessTokenCache = tokens.accessToken
    this.refreshTokenCache = tokens.refreshToken

    this.accessStorage.setValue(tokens.accessToken)
    this.refreshStorage.setValue(tokens.refreshToken)
  }

  clearTokens(): void {
    this.accessTokenCache = null
    this.refreshTokenCache = null

    this.accessStorage.removeValue()
    this.refreshStorage.removeValue()
  }
}

export const tokenStorage = new TokenStorage()
